module.exports = __webpack_public_path__ + "assets/images/CAD5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CAD5.png
// module id = 1329
// module chunks = 1